import FileSaver from 'file-saver';

const saveAsCsv = (header: string[], body: string[][], filename: string): void => {
  const csvRows = [header, ...body];
  const csv = csvRows.map((row) => row.join(',')).join('\r\n');
  const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
  const blob = new Blob([bom, csv], { type: 'text/csv' });

  FileSaver.saveAs(blob, `${filename}.csv`);
};

export default saveAsCsv;
